module.exports = __webpack_public_path__ + "media/Video 94.a60500db.mp4";